import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { CellContext } from '@tanstack/react-table';

export interface ChannelListIsOnlineCellProps
  extends CellContext<GatewayChannelWithChargePointInfoModel, unknown> {}

export const ChannelListIsOnlineCell = (
  props: ChannelListIsOnlineCellProps,
): React.JSX.Element | null => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return row.original.isOnline ? null : <Icon name="wifi-off" />;
};
